export default {
    watchlistLoanDetailModal: {
        isOpen: false,
    },
    watchlistAddLoanModal: {
        isOpen: false,
    },
    groupItemsModal: {
        isOpen: false,
    },
};
